import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../notification/notification.service';

@Component({
  selector: 'app-shopify',
  templateUrl: './shopify.component.html',
  styleUrl: './shopify.component.scss'
})
export class ShopifyComponent implements OnInit {

  isShopEnabled: boolean = false;
  appId: string = '';
  redirectUri: string = location.origin + '/merchants/shopify';
  scopes: string = 'read_orders';
  nonce: string = '';
  creatingAuthUrl: boolean = false;
  shopName: string = '';

  constructor(private http: HttpClient, private route: ActivatedRoute, private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.checkShopify();
    this.route.queryParams.subscribe(params => {
      if(params && params["code"]?.length) {
        this.getAuthToken(params);
      }
    })
  }

  checkShopify() {
    this.http.get<any>('shopify/check').subscribe(res => {
      this.isShopEnabled = !!res?.enabled;
      this.appId = res?.appId || this.appId || '';
      this.shopName = res?.shopName || this.shopName || '';
    })
  }

  private normalizeShopName(value: string): string {
    const raw = (value || '').trim().toLowerCase();
    if(!raw) return '';

    const withoutProtocol = raw.replace(/^https?:\/\//, '');
    const withoutPath = withoutProtocol.split('/')[0].trim();

    if(withoutPath.endsWith('.myshopify.com')) {
      return withoutPath.replace(/\.myshopify\.com$/,'');
    }

    return withoutPath;
  }

  shopToggleChanged(e: any) {
    if(this.isShopEnabled === false) {
      this.notificationService.show("A bekapcsoláshoz jelentkezz be az Shopify-jal!","warning");
      e.preventDefault();
      this.isShopEnabled = false;
    } else {
      this.isShopEnabled = false;
    }
  }

  openShopAuth() {
    const appId = this.appId?.trim();
    const normalizedShop = this.normalizeShopName(this.shopName);
    if(!appId || !normalizedShop) {
      this.notificationService.show("Hiányzik a Shopify shop név vagy a Client ID!","warning");
      return;
    }

    this.creatingAuthUrl = true;
    this.http.get<string>('shopify/nonce').subscribe({
      next: (res) => {
        this.nonce = `${res || ''}`;

        const authUrl = `https://${normalizedShop}.myshopify.com/admin/oauth/authorize?client_id=${encodeURIComponent(appId)}&scope=${encodeURIComponent(this.scopes)}&redirect_uri=${encodeURIComponent(this.redirectUri)}&state=${encodeURIComponent(this.nonce)}`;
        window.open(authUrl,"_self");
      },
      error: (_err) => {
        this.notificationService.show("Hiba történt a nonce létrehozása közben!","danger");
        this.creatingAuthUrl = false;
      }
    });
  }

  private getRawQueryString(): string {
    const raw = window.location.search || '';
    return raw.startsWith('?') ? raw.substring(1) : raw;
  }

  getAuthToken(params: {[key: string]: any}) {
    this.http.post<{result: string}>('shopify/get-token', {
      code: params?.["code"],
      hmac: params?.["hmac"],
      host: params?.["host"],
      shop: params?.["shop"],
      state: params?.["state"],
      timestamp: params?.["timestamp"],
      rawQuery: this.getRawQueryString()
    }).subscribe({
      next: (res) => {
        if(res.result === "ok") {
          this.notificationService.show("Shopify hozzáférés sikeres!","success");
          this.isShopEnabled = true;
          this.checkShopify();
          window.history.replaceState({}, document.title, location.pathname);
        }
      },
      error: (err) => {
        console.log(err);
        this.notificationService.show("Shopify hozzáférés sikertelen!","danger");
      }
    })
  }

  updateOrders() {
    this.http.get<{result: string}>('shopify/update-orders').subscribe({
      next: (res) => {
        if(res.result === "ok") {
          this.notificationService.show("Shopify rendelések frissítése sikeres!","success");
        }
      },
      error: (err) => {
        console.log(err);
        this.notificationService.show("Shopify rendelések frissítése sikertelen!","danger");
      }
    })
  }

}
